<template>
  <section class="page-wrapper">
    <div class="error-content">
      <div class="flex-column align-center">
        <alert-circle-icon size="4.0x" class="alert-circle small-buffer" />
        <h3 class="small-buffer">Invalid Payment Request</h3>
      </div>
      <p class="small-buffer">Cannot find the payment request.</p>
    </div>
  </section>
</template>

<script>
  import { AlertCircleIcon } from "vue-feather-icons";

  export default {
    name: "UpdoxBadPaymentRequestToken",
    components: { AlertCircleIcon },
    props: {
      errorDetails: {
        type: Object,
        required: false,
      },
    },
    computed: {
      error: function () {
        return console.error("UpdoxBadPaymentRequestToken called");
      },
    },
    methods: {},
  };
</script>
<style lang="scss">
  .alert-circle {
    color: red;
  }
  .strong-highlight {
    background-color: yellow;
  }
  .small-buffer {
    margin-bottom: 5px;
  }
</style>
